// Importing React and external libs
import React, { useEffect, useRef, useState } from 'react';

const ACTIVE_SNP_SCREEN_PADDING = 16;
const ACTIVE_SNP_Y_OFFSET = 20; // move div a bit below mouse to avoid tooltip on pointer

export default function ActiveSnp({ chrom, snp, snpYOffset = ACTIVE_SNP_Y_OFFSET }) {
  const activeSnpRef = useRef();
  const [mousePos, setMousePos] = useState(null);

  useEffect(() => {
    const handleMouseMove = (event) => setMousePos({ x: event.clientX, y: event.clientY });

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  if (mousePos === null) return;

  const { width: activeSnpWidth } = activeSnpRef.current?.getBoundingClientRect() ?? { width: 0 };
  const xPos = mousePos.x;
  const yPos = mousePos.y + snpYOffset;
  const boxLeft = mousePos.x - (activeSnpWidth / 2) - ACTIVE_SNP_SCREEN_PADDING;
  const boxRight = mousePos.x + (activeSnpWidth / 2) + ACTIVE_SNP_SCREEN_PADDING;
  const leftOffset = Math.min(0, boxLeft);
  const rightOffset = Math.max(0, boxRight - window.innerWidth);

  return (
    <div ref={activeSnpRef} className="haploblock--active-snp" style={{
      left: xPos + Math.abs(leftOffset) - rightOffset,
      top: yPos,
    }}>
      {snp.snp}, {chrom}:{typeof snp.position === 'number' ? snp.position.toLocaleString() : ''}, {snp.call}
      &nbsp;
    </div>
  );
}